import { render, staticRenderFns } from "./Sources.vue?vue&type=template&id=d4b7a6d0&"
import script from "./Sources.vue?vue&type=script&lang=js&"
export * from "./Sources.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports